import type { ThemeConfig } from "antd";

export const shixiangjiTheme:ThemeConfig={
  token:{colorPrimary:"#7c9059",colorInfo:"#7c9059",colorBgBase:"#fafbf7",colorBgContainer:"#ffffff",colorBgElevated:"#ffffff",colorBgLayout:"#f5f6ef",colorText:"#29392d",colorTextSecondary:"#88917d",colorBorder:"#e3e8d9",borderRadius:12,fontSize:13,fontFamily:"system-ui, -apple-system, 'PingFang SC', 'Microsoft YaHei', sans-serif"},
  components:{Button:{primaryShadow:"none",controlHeight:38},Table:{headerBg:"#f0f3e8",headerColor:"#4d6340",rowHoverBg:"#f8faf3"},Tag:{defaultBg:"#edf2e2",defaultColor:"#718455"}},
};
